import React from "react";
import last from "lodash/last";
import sortBy from "lodash/sortBy";
import { useParams } from "react-router-dom";

import { ProgramHeaderItemState } from "./enum";
import { getStagesForProgramHeader } from "./utils";
import { DISPLAY_ORDER_KEY } from "shared/utils/constants";
import { ProgramHeaderPropTypes, ProgramHeaderServicePropTypes } from "./types";
import { useProgramHeaderBehaviourFactory } from "./behaviour/ProgramHeaderBehaviourFactory";

export default function useProgramHeaderService(props: ProgramHeaderPropTypes): ProgramHeaderServicePropTypes {
  const { programParticipantId } = useParams();
  const programHeaderBehaviour = useProgramHeaderBehaviourFactory();

  const programHeaders = React.useMemo(() => {
    if (!props.programDetails.skippedTimelineStages || !props.programDetails.programStatus) return [];
    const currentProgramStage = props.programDetails.programStatus;
    const currentProgramType = props.programDetails.programType;
    return getStagesForProgramHeader({
      currentProgramStage,
      programHeaderStagesList: programHeaderBehaviour.getProgramStatusHeaderList(
        currentProgramType,
        currentProgramStage,
        programParticipantId
      ),
      skippedStages: props.programDetails.skippedTimelineStages
    });
  }, [props.programDetails, programHeaderBehaviour, programParticipantId]);

  const defaultPath = React.useMemo(() => {
    const currentStage = programHeaders.find(o => o.status === ProgramHeaderItemState.ON_GOING)?.path;
    if (currentStage) {
      return currentStage;
    }
    // return the path of last stage when program is completed
    return last(sortBy(programHeaders, DISPLAY_ORDER_KEY))?.path;
  }, [programHeaders]);

  return {
    defaultPath,
    programHeaders
  };
}
